module.exports = __webpack_public_path__ + "static/img/core3.63c92c78.png";